export const abvOptions = [
    {
        label: 'Non-Alcoholic (<2%)',
        value: '0,2',
    },
    {
        label: 'Low (2-4.5%)',
        value: '2,4.5',
    },
    {
        label: 'Normal (4.5-6.5%)',
        value: '4.5,6.5',
    },
    {
        label: 'Elevated (6.5-8.5%)',
        value: '6.5,8.5',
    },
    {
        label: 'High (8.5-12%)',
        value: '8.5,12',
    },
    {
        label: 'Extremely High (> 12%)',
        value: '12,99',
    },
]
